<template>
    <div class="album">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="gray" class="bi bi-album"
            viewBox="0 0 16 16">
            <path
                d="M.54 3.87.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a2 2 0 0 1 .342-1.31zM2.19 4a1 1 0 0 0-.996 1.09l.637 7a1 1 0 0 0 .995.91h10.348a1 1 0 0 0 .995-.91l.637-7A1 1 0 0 0 13.81 4zm4.69-1.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139q.323-.119.684-.12h5.396z" />
        </svg>
        <div class="">
            <form @submit.prevent="saveAlbum" class="add-album-input-container">
                <input v-model="albumName" class="add-album-input input" placeholder="Album name" @input="hideMissingNameError">
                <button class="button-primary icon-button" type="submit">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                        class="bi bi-check" viewBox="0 0 16 16">
                        <path
                            d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z" />
                    </svg>
                </button>
            </form>
          <p v-if="showMissingNameError" class="input-error">Enter a name.</p>
        </div>
    </div>
</template>

<script setup>
import apiService from '@/services/apiService';
import { ref } from 'vue';
import { useRouter } from 'vue-router'

const router = useRouter();

const albumName = ref('');
const showMissingNameError = ref(false);

async function saveAlbum() {
    if (albumName.value.trim() === "") {
      showMissingNameError.value = true;
      return;
    }
    let album = { "name": albumName.value };
    const result = await apiService.createAlbum(album);
    router.push("/albums/" + result.id);
}

function hideMissingNameError() {
  showMissingNameError.value = false;
}

</script>

<style scoped>
.album {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px solid lightgray;
    border-radius: 10px;
    padding: 2rem;
    margin: 1rem;
    gap: 10px;
    transition: all 0.15s ease-in-out;
}

.album:hover {
    border-color: gray;
}

.add-album-input {
    margin-right: 0.5rem;
}

.add-album-input-container {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
}

.input-error {
  font-size: 0.8rem;
}
</style>